<!-- <mat-accordion [multi]="false" class="main-nav-list">
  <mat-list-item class="more-side-btn">
    <a [routerLink]="'/'" class="list-menu" routerLinkActive="active-list-item"
      [routerLinkActiveOptions]="{ exact: true }">
      <fa-icon class="mat-icon" [icon]="iconList[0]" matTooltip="item.name"></fa-icon>
    </a>
  </mat-list-item>
  <ng-container *ngFor="let item of navigationList; let i = index">
    <ng-container *ngIf="item.childRoute; else singleNavItem">
      <mat-expansion-panel class="sidenav-main group-link" [hideToggle]="true" [expanded]="i === expandedIndex"
        (click)="onPanelClick(i)">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <fa-icon class="mat-icon" [icon]="item.icon" [matTooltip]="item.name" [routerLink]="item.route"
              routerLinkActive="active-list-item" [routerLinkActiveOptions]="{ exact: true }"></fa-icon>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <ng-container *ngFor="let child of item.childRoute">
          <ng-container *ngIf="child.childRoute; else subNavItem">
            <mat-expansion-panel class="sidenav-main" [hideToggle]="true">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <fa-icon class="mat-icon" [icon]="child.icon" [matTooltip]="child.name"></fa-icon>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <ng-container *ngFor="let subChild of child.childRoute">
                <mat-list-item>
                  <a [routerLink]="[subChild.route]" class="list-menu" routerLinkActive="active-list-item" (click)="$event.stopPropagation()"
                    [routerLinkActiveOptions]="{ exact: true }">
                    <fa-icon class="mat-icon" [icon]="subChild.icon" [matTooltip]="subChild.name"></fa-icon>
                  </a>
                </mat-list-item>
              </ng-container>
            </mat-expansion-panel>
          </ng-container>

          <ng-template #subNavItem>
            <mat-list-item *ngIf="child.route && child.route !== '#'">
              <a [routerLink]="[child.route]" class="list-menu" routerLinkActive="active-list-item" (click)="$event.stopPropagation()"
                 [routerLinkActiveOptions]="{ exact: true }">
                <fa-icon class="mat-icon" [icon]="child.icon" [matTooltip]="child.name"></fa-icon>
              </a>
            </mat-list-item>
            <mat-list-item *ngIf="!child.route || child.route === '#'">
              <a  class="list-menu" routerLinkActive="active-list-item" (click)="callRouteFunction(child);$event.stopPropagation()"
                 [routerLinkActiveOptions]="{ exact: true }">
                <fa-icon class="mat-icon" [icon]="child.icon" [matTooltip]="child.name"></fa-icon>
              </a>
            </mat-list-item>
          </ng-template>
          
        </ng-container>
      </mat-expansion-panel>
    </ng-container>

    <ng-template #singleNavItem>
      <mat-list-item>
        <a [routerLink]="[item.route]" class="list-menu" routerLinkActive="active-list-item"
          [routerLinkActiveOptions]="{ exact: true }">
          <fa-icon class="mat-icon" [icon]="item.icon" [matTooltip]="item.name"></fa-icon>
        </a>
      </mat-list-item>
    </ng-template>
  </ng-container>

  <mat-list-item class="more-side-btn">
    <a [routerLink]="'#'" class="list-menu" routerLinkActive="active-list-item"
      [routerLinkActiveOptions]="{ exact: true }">
      <fa-icon class="mat-icon" [icon]="iconList[1]" matTooltip="Settings"></fa-icon>
    </a>
  </mat-list-item>
  <mat-list-item class="more-side-btn">
    <a [routerLink]="'#'" class="list-menu" routerLinkActive="active-list-item"
      [routerLinkActiveOptions]="{ exact: true }">
      <fa-icon class="mat-icon" [icon]="iconList[2]" matTooltip="Settings"></fa-icon>
    </a>
  </mat-list-item>
</mat-accordion> -->

<!-- app.component.html -->
<mat-sidenav-container class="sidenav-container">
  <!-- Sidenav -->
  <mat-sidenav #sidenav mode="side" [opened]="true">
    <mat-nav-list>
      <a mat-list-item routerLink="/" routerLinkActive="active-link">
        <mat-icon>home</mat-icon>
        Home
      </a>
      <a mat-list-item routerLink="/about" routerLinkActive="active-link">
        <mat-icon>info</mat-icon>
        About
      </a>
      <a mat-list-item routerLink="/contact" routerLinkActive="active-link">
        <mat-icon>contact_mail</mat-icon>
        Contact
      </a>
    </mat-nav-list>
  </mat-sidenav>

  <!-- Main Content -->
  <mat-sidenav-content>
    <div class="content-container">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
